import React, { useEffect, useRef } from 'react';
import { Workspace } from './types';

interface WorkspaceContextMenuProps {
  workspace: Workspace;
  anchorEl: HTMLElement;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

const WorkspaceContextMenu: React.FC<WorkspaceContextMenuProps> = ({
  workspace,
  anchorEl,
  onRename,
  onDelete,
  onClose,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    // Delay to prevent the same click from closing
    const timer = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
    }, 0);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Position below the anchor element
  const rect = anchorEl.getBoundingClientRect();
  const style: React.CSSProperties = {
    top: rect.bottom + 4,
    left: rect.left,
  };

  // Prevent menu from going off-screen right
  if (rect.left + 160 > window.innerWidth) {
    style.left = window.innerWidth - 170;
  }

  return (
    <div className="workspace-context-menu" style={style} ref={menuRef}>
      <button
        className="context-menu-item"
        onClick={() => {
          onRename();
          onClose();
        }}
      >
        <span className="context-menu-icon">✏️</span>
        Rename
      </button>
      {!workspace.isDefault && (
        <button
          className="context-menu-item danger"
          onClick={() => {
            onDelete();
            onClose();
          }}
        >
          <span className="context-menu-icon">🗑️</span>
          Delete
        </button>
      )}
    </div>
  );
};

export default WorkspaceContextMenu;
